import { render, staticRenderFns } from "./cohort-access.vue?vue&type=template&id=ceb2d1e8&"
import script from "./cohort-access.ts?vue&type=script&lang=ts&"
export * from "./cohort-access.ts?vue&type=script&lang=ts&"
import style0 from "./cohort-access.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports